import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { borderRadius, colors, fontSize } from '../../../constants/styleConstants';
import TextField from '../TextField';

const useStyles = makeStyles(() => ({
  inputRoot: {
    border: `1px solid ${colors.fieldsBorderGray}`,
    borderRadius: borderRadius.fields,
    padding: '8px 10px !important',
    fontSize: fontSize.textFieldLabel,
    backgroundColor: colors.white,
    '&::before': {
      content: "''",
      display: 'none',
    },
    '&::after': {
      content: "''",
      display: 'none',
    },
  },
  textBox: {
    overflow: 'auto',
  },
  input: {
    height: 'auto !important',
    '&:focus': {
      backgroundColor: colors.white,
    },
  },
  focused: {
    backgroundColor: colors.white,
  },
}));
// TODO think if we can remove it to TextField with input props
const TextArea = ({ text, className, maxLines, minLines, onChange, ...rest }) => {
  const classes = useStyles();

  return (
    <TextField
      id="html-text-field"
      {...(text ? { value: text } : {})}
      {...(onChange ? { onChange: e => onChange(e.target?.value) } : {})}
      inputClasses={{
        inputMultiline: classes.textBox,
        root: classnames(classes.inputRoot, className),
        input: classes.input,
        focused: classes.focused,
      }}
      fullWidth
      multiline
      rowsMax={maxLines}
      rows={minLines}
      {...rest}
    />
  );
};

TextArea.propTypes = {
  text: PropTypes.string,
  className: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  maxLines: PropTypes.number,
  minLines: PropTypes.number,
  label: PropTypes.string,
  field: PropTypes.object,
  required: PropTypes.bool,
};

TextArea.defaultProps = {
  maxLines: 5,
  minLines: 5,
  field: {
    name: '',
  },
};

export default TextArea;
